import React from "react";
import classNames from "classnames";
import { useFormContext, ValidationRule } from "react-hook-form";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
export const SowCustomInputField = (props: FormInputFieldProps) => {
	const {
		id = undefined,
		label,
		labelClassName,
		inputClassName = undefined,
		className,
		type = "text",
		placeholder = undefined,
		name,
		required = false,
		pattern,
		validate,
		disabled = false,
	} = props;

	const labelClasses = classNames("label", labelClassName);

	const inputClass = classNames(inputClassName, {
		"input input--med":
			inputClassName == undefined || inputClassName == null,
	});

	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: required,
			message: "COMMON.REQUIRED_FIELD",
		},
		pattern,
		validate,
	});

	return (
		<div className={className}>
			<label htmlFor={id} className={labelClasses}>
				{label} <RequiredMark required={required} />
			</label>
			<ErrorMessage name={name} />
			<input
				type={type}
				id={id}
				className={inputClass}
				placeholder={placeholder || ""}
				{...field}
				disabled={disabled}
			/>
		</div>
	);
};

type FormInputFieldProps = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	"pattern"
> & {
	name: string;
	label?: string;
	labelClassName?: string;
	inputClassName?: string;
	placeholder?: string;
	popoverMsg?: React.ReactNode | string;
	errorMessage?: string;
	pattern?: ValidationRule<RegExp>;
	//@ts-expect-error
	validate?: Validate<any> | Record<string, Validate<any>>;
	asterisksClass?: string | null;
};
